import { createApp } from "//omikujistore.com/cdn/shop/t/10/assets/lib.vue.js?v=39460745490713962181759520844";

function ShopifyHooks(appContainer, appState) {
	return {
		mounted() {
			appState.mounted = true;
		},
		unmounted() {
			appContainer.innerHTML = this.rawLiquidInput.innerHTML;
			appState.mounted = false;
		},
	};
}

function useShopifyLiquidInput(rawInput) {
	if (!rawInput || rawInput.innerText == "") return { };

	const liquid = JSON.parse(rawInput.innerText);

	return liquid;
}

function propsFromLiquid(rawLiquidInput, id) {
	const rawLiquidVariables = rawLiquidInput.getElementsByClassName("liquid-variables")[0];
	const rawLiquidBlocks = rawLiquidInput.getElementsByClassName("liquid-blocks")[0];
	const rawLiquidSettings = rawLiquidInput.getElementsByClassName("liquid-settings")[0];
	
	const LiquidVariables = useShopifyLiquidInput(rawLiquidVariables);
	const LiquidBlocks = useShopifyLiquidInput(rawLiquidBlocks);
	const LiquidSettings = useShopifyLiquidInput(rawLiquidSettings);

	const errorForms = rawLiquidInput.getElementsByClassName("liquid-form-errors")[0];

	let LiquidFormErrors = null;
	let rawErrors = null;
	if (errorForms)
		rawErrors = errorForms.getElementsByClassName("liquid-actual-errors");
	if (rawErrors) {
		let tmp = [];
		for(const rawError of rawErrors) {
			tmp = [...tmp, ...useShopifyLiquidInput(rawError)];
		}
		LiquidFormErrors = tmp;
	}

	return {
		liquid: {
			variables: LiquidVariables,
			blocks: LiquidBlocks,
			settings: LiquidSettings,
			formErrors: LiquidFormErrors,
			id
		}
	}
}

function CreateAndStoreApp(component, id, appContainer, props) {
	const appState = { mounted: false }
	const hooks = ShopifyHooks(appContainer, appState);
	const rawLiquidInput = appContainer.cloneNode(true);
	const liquidProps = propsFromLiquid(rawLiquidInput, id)
	const app = createApp({
		...hooks,
		...component,
	}, {...liquidProps, ...props});

	window.shopifyVueApps.set(id, {app, id, component, appContainer, appState, props});
	app.config.globalProperties.rawLiquidInput = rawLiquidInput;
	app.mount(`#${id}`);
}

function ShopifyVueCreateApp(component, id, props = null) {
	if (!window.shopifyVueApps) window.shopifyVueApps = new Map();
	
	component.name = id;
	const baseProps = { designMode: Shopify.designMode }
	const appContainer = document.getElementById(id);
	CreateAndStoreApp(component, id, appContainer, { ...props, ...baseProps});
}

if (Shopify.designMode) {

	function vueShopifyCtx(target) {
		const vpifyRoot = target.querySelectorAll("[vpify-root]")[0]		
		if (!vpifyRoot)
			return null;
		const elemId = vpifyRoot.id;
		if (!elemId || !window.shopifyVueApps.has(elemId))
			return null;
		return window.shopifyVueApps.get(elemId)
	}

	document.addEventListener("shopify:section:load", (e) => {
		setTimeout(() => {
			const ctx = vueShopifyCtx(e.target)
			if (ctx.appState.mounted)
				return;
			const component = ctx.component;
			const appContainer = ctx.appContainer;
			CreateAndStoreApp(component, ctx.id, appContainer);	
		}, 1500);
	})

	document.addEventListener("shopify:section:unload", (e) => {
		const ctx = vueShopifyCtx(e.target)
		if (!ctx.appState.mounted)
			return;
		ctx.app.unmount()
	})
}

export { ShopifyVueCreateApp };
